module.exports = __webpack_public_path__ + "img/noname.326082d8.png";